const ADMIN_ROLE_NAMES = ["owner", "ceo", "vp", "director", "manager"];
const OWNER_ROLE_NAMES = ["owner"];

export const parsePermissions = (permissions) => {
  if (!permissions) return [];
  if (Array.isArray(permissions)) return permissions.map((p) => String(p).trim());
  if (typeof permissions === "object") {
    const list = [];
    if (permissions.create) list.push("create");
    if (permissions.read) list.push("read");
    if (permissions.update) list.push("update");
    if (permissions.delete) list.push("delete");
    if (permissions.read_all || permissions.readAll) list.push("readall");
    if (permissions.modify_all || permissions.modifyAll) list.push("modifyall");
    return list;
  }
  return String(permissions).split(",").map((p) => p.trim()).filter(Boolean);
};

export const hasPermission = (permissionString, permission) => {
  const list = parsePermissions(permissionString);
  return list.includes(permission) || list.includes("modifyall");
};

export const hasAnyPermission = (permissionString, permissions) => {
  const list = parsePermissions(permissionString);
  return (
    list.includes("modifyall") ||
    permissions.some((permission) => list.includes(permission))
  );
};

export const hasAdminAccess = (user) => {
  if (!user) return false;
  const roleLevel = Number(user.role_level ?? user.roleLevel);
  const roleName = String(user.role_name || user.roleName || "").toLowerCase();
  const hasAdminRole =
    user.is_admin ||
    user.isAdmin ||
    ADMIN_ROLE_NAMES.includes(roleName) ||
    (Number.isFinite(roleLevel) && roleLevel <= 4);
  if (!hasAdminRole) return false;
  return hasAnyPermission(user.permission || user.permissions, ["read", "readall"]);
};

export const isOwnerUser = (user) => {
  if (!user) return false;
  const roleLevel = Number(user.role_level ?? user.roleLevel);
  const roleName = String(user.role_name || user.roleName || "").toLowerCase();
  return (
    user.is_owner ||
    user.isOwner ||
    OWNER_ROLE_NAMES.includes(roleName) ||
    (Number.isFinite(roleLevel) && roleLevel <= 1)
  );
};
